<template>
  <div class="h-full flex items-center">
    <el-input
      size="small"
      :placeholder="placeholder"
      :value="name"
      clearable
      :disabled="disabled"
      @clear="clearName"
      class="flex-1"
    >
    </el-input>
    <button
      class="handle_btn search ml-10px"
      :disabled="disabled"
      type="button"
      @click="initDialog"
    >
      选择预案
    </button>
    <div class="fixed inset-0 z-1000" @click.stop v-if="visible">
      <CockpitDialog
        title="选择应急预案"
        left="580px"
        width="990px"
        height="650px"
        top="120px"
        @close="visible = false"
      >
        <div class="flex mb-10px mr-10px">
          <el-input
            v-model.trim="searchData.keyword"
            size="small"
            :placeholder="`${$t('预案编号、名称')}`"
            class="w-50 mr-10px"
            clearable
          ></el-input>
          <el-select
            v-model="searchData.categoryId"
            size="small"
            :placeholder="`${$t('预案类别')}`"
            class="w-50 mr-10px"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in categoryList"
              :key="index"
              :label="item.displayName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-model="searchData.typeName"
            size="small"
            :placeholder="`${$t('预案类型')}`"
            class="w-50 mr-10px"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
          <button
            class="handle_btn search mr-10px"
            size="small"
            type="button"
            @click="handleSearch()"
          >
            搜索
          </button>
          <button class="handle_btn" size="small" type="button" @click="resetSearch">
            重置
          </button>
        </div>
        <el-table :data="tableData" class="w-full " :height="tableHeight" v-loading="tableLoading">
          <el-table-column :label="`${$t('序号')}`" type="index" width="60"></el-table-column>
          <el-table-column
            :label="`${$t('预案编号')}`"
            prop="no"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('预案名称')}`"
            prop="name"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :label="`${$t('预案类别')}`" prop="categoryName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            :label="`${$t('预案类型')}`"
            prop="typeName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('所属部门')}`"
            prop="eascOrganizationName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('应急响应等级')}`"
            prop="gradeName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" width="140">
            <template slot-scope="scope">
              <!-- <el-button size="mini" @click.native="goPlan(scope.row, 'read')">查看</el-button>
              <el-button size="mini" @click.native="handleSelect(scope.row, 'read')"
                >选择</el-button
              > -->
              <span class="text-[#00bccb] mr-10px cursor-pointer" @click="goPlan(scope.row, 'read')"
                >查看</span
              >
              <span class="text-[#00bccb] cursor-pointer" @click="handleSelect(scope.row, 'read')"
                >选择</span
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="tableSizeChange"
          @current-change="tableCurrentChange"
          :current-page.sync="pageConfig.SkipCount"
          :page-size.sync="pageConfig.MaxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="totalCount"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </CockpitDialog>
    </div>
  </div>
</template>

<script>
import { PlanApi } from '@wiz-api/emergency-management'
// import utils from '@/components/safety/enumField/utils'
import CockpitDialog from '@/components/cockpit/CockpitDialog'

const planApi = new PlanApi()
export default {
  name: 'preplan-select',
  components: {
    CockpitDialog,
  },

  props: {
    placeholder: {
      default: '请选择应急预案',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: '',
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      name: '',
      categoryList: [],
      tableLoading: false,
      visible: false,
      tableData: [],

      searchData: {},
      totalCount: 0,
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  created() {
    this.getList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 120px)'
    },
    typeList() {
      return [
        {
          value: 1,
          label: this.$t('综合应急预案'),
        },
        {
          value: 2,
          label: this.$t('专项应急预案'),
        },
        {
          value: 3,
          label: this.$t('现场处置方案'),
        },
      ]
    }, // 预案类型下拉框数据
  },
  watch: {
    value(val) {
      if (val) {
        this.getName(val)
      } else {
        this.name = ''
      }
    },
  },
  methods: {
    async getName(id) {
      if (!id) return
      const [err, res] = await planApi.get(id)
      if (!err) {
        this.name = res.name
      }
    },
    clearName() {
      this.$emit('change', '')
    },
    // 初始化弹窗
    initDialog() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
      this.visible = true
      this.getName()
    },
    handleSelect(row) {
      this.name = row.name
      this.$emit('change', row.id)
      this.visible = false
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getList()
    },

    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getList()
    },
    resetSearch() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 获取应急预案列表
    async getList() {
      const [err, res] = await planApi.getList({
        ...this.searchData,
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
      })
      this.tableLoading = true
      if (!err) {
        this.tableData = res.items
        this.totalCount = res.totalCount
      }
      this.tableLoading = false
    },
    async goPlan(planRow, type = 'read') {
      let path = ''
      if (planRow.typeName === this.$t('综合应急预案')) {
        path = '/contingency-plan/comprehensive-plan'
      } else if (planRow.typeName === this.$t('专项应急预案')) {
        path = '/contingency-plan/special-plan'
      } else if (planRow.typeName === this.$t('现场处置方案')) {
        path = '/contingency-plan/onsite-disposal-plan'
      }
      window.sessionStorage.setItem('planRow', JSON.stringify(planRow))
      if (type === 'approval') {
        const routeUrl = this.$router.resolve({
          path,
          query: {
            operateType: type,
            planRowId: planRow.id,
          },
        })
        window.open(routeUrl.href, '_blank')
      } else {
        const routeUrl = this.$router.resolve({
          path,
          query: {
            operateType: type,
            planRowId: planRow.id,
          },
        })
        window.open(routeUrl.href, '_blank')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.handle_btn {
  height: 32px;
  width: 96px;
  border-radius: 32px;
  background: linear-gradient(180deg, #137ee566 0%, #19a4da66 100%),
    linear-gradient(-180deg, #05bdff00 0%, #3bfff566 100%);
  box-shadow: inset 0px 1px 15px 0px #77c4ff33;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
}
.search {
  background: #4dc2d2;
}
.handle_btn[disabled] {
  cursor: no-drop;
}
::v-deep .el-input__validateIcon {
  display: none;
}
</style>
